import { useTranslation } from "react-i18next";

import * as api from "shared/api/methods";

import { useFetch } from "hooks/useFetch";

import { getLoansOptions } from "./CalculatorForm.helpers";
import { useCommon } from "context/common";

export const useCalculatorForm = ({
  isAuthenticated,
}: {
  isAuthenticated: boolean;
}) => {
  const { getParam } = useCommon();
  const defaultCalculationValues = getParam("calculation");

  const { t } = useTranslation();

  const { loading: loadingCalculationValues, data: calculationValues } =
    useFetch(
      {
        defaultData: {},
        fetcher: api.getCalculationValues,
        immediately: true,
        stopRequest: false,
      },
      null,
      [isAuthenticated]
    );

  const { loading: directoryStagesLoading, data: stagesOptions } = useFetch(
    {
      defaultData: [],
      fetcher: api.getDirectoryByType,
      immediately: true,
      stopRequest: false,
    },
    "stages",
    []
  );

  const { loading: loadingLoans, data: loans } = useFetch(
    {
      defaultData: [],
      fetcher: api.getLoans,
      immediately: true,
      stopRequest: false,
    },
    [],
    []
  );

  const loading =
    loadingCalculationValues || directoryStagesLoading || loadingLoans;

  const loansOptions = getLoansOptions({ t, loans });

  return {
    loading,
    loans,
    calculationValues,
    stagesOptions,
    loansOptions,
    defaultCalculationValues
  };
};
